export const BASE_URL =
  window.location.host.indexOf("localhost") < 0
    ? window.location.protocol + "//" + window.location.host
    : "https://hechengii.doylear.space";

export const url =
  window.location.host.indexOf("localhost") < 0
    ? window.location.host
    : "https://www.yovolumy.shop";

export default {
  PAY: "/create_payment.php",
};
